module.exports = __webpack_public_path__ + "media/img/pages/companies/air_up-27c71ae6a2fb57a6fb50470efcb0aa39.png";